var TuVocab = {
  BRAND_NAME: 'Tu',
  ADD_TO_TROLLEY: 'Add to basket',
  ITEM_CONTAINER: 'basket',
  CREDIT_URL: '/help/argos-card'
};
export default TuVocab;